import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
const steps = ['Review the clinical volumes.', 'Explore the algorithms.', 'Open the case library.', 'Use the practical resources.'];
export function Guarantee() {
  return <section className="bg-ink-900 px-5 py-14 sm:px-8 sm:py-20" data-id="element-184" data-mp="29dwydyq7zfxh">
      <div className="mx-auto max-w-3xl" data-id="element-185" data-mp="29f80lu40ofmh">
        <div className="rounded-3xl border border-teal-400/30 bg-ink-800/70 p-6 sm:p-10" data-id="element-186" data-mp="2ed9t15nc1ram">
          <div className="flex flex-col items-center text-center" data-id="element-187" data-mp="2jc4aa35nj7sm">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-teal-400/15" data-id="element-188" data-mp="2ja9raudxxpr6">
              <ShieldCheckIcon className="h-8 w-8 text-teal-300" aria-hidden="true" data-id="element-189" data-mp="2o9340klelcqa" />
            </span>
            <h2 className="mt-4 font-display text-2xl font-bold uppercase leading-tight tracking-tight text-white sm:text-4xl" data-id="element-190" data-mp="2saomqmkmcl8e">
              Your 7-Day Guarantee
            </h2>
            <p className="mt-2 font-display text-base font-bold uppercase tracking-[0.14em] text-teal-300 sm:text-lg" data-id="element-191" data-mp="xz9vg1bymdqj">
              Review it. Use it. Decide for yourself.
            </p>
          </div>

          <p className="mt-6 text-center text-[15px] leading-relaxed text-white/75 sm:text-base" data-id="element-192" data-mp="3ntf1250h64dn">
            You have 7 days to explore the Master System of TRT™.
          </p>

          <ul className="mx-auto mt-5 grid max-w-md gap-2" data-id="element-193" data-mp="3dxv73o5h1frj">
            {steps.map(step => <li key={step} className="rounded-xl bg-ink-900/70 px-4 py-3 text-sm font-medium text-white/85 sm:text-base" data-id="element-194" data-mp="fdllbsdywwxn">
                {step}
              </li>)}
          </ul>

          <p className="mt-6 text-center text-[13px] leading-relaxed text-white/60 sm:text-sm" data-id="element-195" data-mp="5ijxr0zcc2x6">
            If you decide it’s not the right resource for your needs, contact support within the
            applicable 7-day period and request a refund according to the refund policy.
          </p>

          <div className="mx-auto mt-8 max-w-md" data-id="element-196" data-mp="2la7scpqvtjct">
            <CtaButton label="Get Access for $27" subLabel="Try the Master System of TRT™ with confidence" data-id="element-197" data-mp="1d9h7sqq9bhii" />
          </div>
        </div>
      </div>
    </section>;
}